<template>
  <v-container>
      <div class="body-text text-white mt-4">
        <h1 style="color: white; font-weight: 300;" class="text-h3">
          {{ props.title }}
        </h1>
      </div>
      <div class="body-text mt-4" style="color: white;">
        <br />
        <span v-html="reportSubText">
        </span>
        <PleaseNote v-if="pleaseNote"></PleaseNote>
      </div>
  </v-container>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <div>
            <v-select class="text-white" style="min-width: 50vw;" label="Select Report" v-model="selectedReport"
                :items="reports" item-title="ReportTitle" item-value="Id" item-text="ReportTitle" variant="outlined"
                @update:modelValue="reportChanged"
                aria-label="Select Report"></v-select>
                <div v-show="showDownloadOnly">
                  <v-switch :style="downloadOnly === true ? 'color: #BBDEFB;' :'color: darkgrey;'"
                    v-model="downloadOnly"
                    label="Download Only"
                    color="blue-lighten-4"
                    @update:modelValue="downloadOnlyChanged"
                  ></v-switch>                  
                </div>              
        </div>
      </v-col>
      </v-row>
  </v-container>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useReportsStore } from '@/stores/reports'
import PleaseNote from '@/components/PleaseNote.vue'

const reportsStore = useReportsStore()

const reports = ref([])
const selectedReport = ref(null)
const downloadOnly = ref(false)
const reportSubText = ref('')

const emit = defineEmits(['reportChanged', 'downloadOnlyChanged'])

const props = defineProps({
  title: { type: String, required: true },
  filter: { type: String, required: true },
  showDownloadOnly: { type: Boolean, default: false},
  pleaseNote: { type: Boolean, default: false},
})

const getReports = () => {
  reportsStore.getReports(props.filter).then(result => {
    if (result.success === true) {
      if (result.hasData) {
        reports.value = JSON.parse(result.reportData);
        reports.value.forEach(element => {
          if (element.Params.length > 0) {
            element.Params = JSON.parse(element.Params) 
          }
        });
      }
    }
  }).catch(error => {
      console.log(`get title`, error)
  })
}

const reportChanged = (value) => {
  let report = reports.value.find(item => item.Id === value)
  reportSubText.value = report.ReportSubText
  emit('reportChanged', report)
}

const downloadOnlyChanged = (value) => {
  emit('downloadOnlyChanged', value)
}

onMounted(() => {
  getReports()
})



</script>

<style scoped>

</style>